import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { BASE_URL } from '../constants';

const BASE_QUERY_KEY = `/public/aiConversation/<id>/template`;

export function usePublicAIConversationAgentTemplateQuery({ id, enabled }: { id: string; enabled?: boolean }) {
	return useQuery({
		queryFn: async () => {
			const response = await fetch(`${BASE_URL}/public/aiConversation/${id}/template`);
			const data: Api.IOperationResult<Api.IAIAgentTemplate> = await response.json();
			if (!data.success) {
				throw new Error(data.systemMessage);
			}
			return data.value;
		},
		queryKey: [BASE_QUERY_KEY, id],
		enabled,
	});
}
